export default __webpack_public_path__ + "static/arrow-5458090a21f6161b9c5fad23ad336b47.svg";